import { useEffect } from "react";
import { useProjectContext } from "@contexts/projects";
import { useTitleAnnulments } from "@components/titleAnnulments/TitleAnnulmentsContext";
import TitleAnnulmentsManager from "@components/titleAnnulments/TitleAnnulmentsManager";

// "Títulos > Títulos anulados": a lista da construtora da obra aberta, em página. A construtora e
// a empresa no ERP vêm da obra, então o cliente só cola os números. Os dados são os do
// `TitleAnnulmentsContext` (o mesmo da barra lateral), carregados ao abrir a página.
const TitleAnnulmentsPage = () => {
  const { activeProject, companies, projects } = useProjectContext();
  const { data, status, load, reload } = useTitleAnnulments();
  const projectId = activeProject?._id;
  const company = companies?.find((entry) => entry._id === activeProject?.company_id);

  useEffect(() => {
    if (projectId) load({ force: true });
  }, [projectId, load]);

  return (
    <div className="ta-page">
      <header className="ta-page__header">
        <p className="ta-page__eyebrow">Títulos</p>
        <h1 className="ta-page__title">Títulos anulados na Ampli</h1>
        <p className="ta-page__lead">
          {`Títulos do ERP que ${company?.name ? `a ${company.name}` : "a construtora"} tirou da conta da Ampli. `}
          O ERP não muda: o título sai da tendência, do comprometido, do pago e do a pagar de todas as obras, e volta quando é reincluído.
        </p>
      </header>
      {!projectId ? (
        <p className="ta-muted">Escolha uma obra para ver os títulos anulados da construtora.</p>
      ) : (
        <TitleAnnulmentsManager
          variant="page"
          projectId={projectId}
          status={status}
          data={data}
          project={activeProject}
          projects={projects}
          erp={company?.erp}
          reload={reload}
        />
      )}
    </div>
  );
};

export default TitleAnnulmentsPage;
